import { render, staticRenderFns } from "./or_kyjs_report.vue?vue&type=template&id=0960017b&scoped=true"
import script from "./or_kyjs_report.vue?vue&type=script&lang=js"
export * from "./or_kyjs_report.vue?vue&type=script&lang=js"
import style0 from "./or_kyjs_report.vue?vue&type=style&index=0&id=0960017b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0960017b",
  null
  
)

export default component.exports